import { staticPlanSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-plan-sidebar/index.tsx';
import type { PlanSidebarNavInfo } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/plan-sidebar-navigation/types.tsx';
import { useResource } from '@atlassian/react-resource-router';

/** Returns the data needed for the plan sidebar navigation. */
export const usePlan = () =>
	useResource<PlanSidebarNavInfo | null>(staticPlanSidebarNavigationResource);
